// @flow
import { commitMutation, graphql } from 'react-relay';

export const mutation = graphql`
  mutation CartAdjustAutoshipMutation(
    $input: CartAdjustAutoshipMutationInput!
  ) {
    cartAdjustAutoship(input: $input) {
      cart {
        id
        autoShipEnabled
        autoShipIntervalUnit
        autoShipIntervalCount
        enrollingAsPc
      }
    }
  }
`;

function getOptimisticResponse({
  cart,
  autoShipIntervalUnit,
  autoShipIntervalCount,
}) {
  return {
    cartAdjustAutoship: {
      cart: {
        id: cart.id,
        autoShipEnabled: cart.autoShipEnabled,
        autoShipIntervalUnit,
        autoShipIntervalCount,
        enrollingAsPc: cart.enrollingAsPc,
      },
    },
  };
}

function commit({
  cart,
  autoShipIntervalUnit,
  autoShipIntervalCount,
  environment,
  onCompleted,
  onError,
}) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        autoShipIntervalCount,
        autoShipIntervalUnit,
      },
    },
    optimisticResponse: getOptimisticResponse({
      cart,
      autoShipIntervalCount,
      autoShipIntervalUnit,
    }),
    onCompleted,
    onError,
  });
}

export default { commit };
